import React from "react";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Link,
    styled,
    useMediaQuery,
    Typography,
    Divider
} from "@mui/material";
import { format } from "date-fns";
import GetAppIcon from '@mui/icons-material/GetApp';

const StyledTableContainer = styled(TableContainer)({
    backgroundColor: "#181818",
    borderRadius: "8px",
    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
    overflow: "hidden",
    "&::-webkit-scrollbar": {
        width: 0,
    },
    padding: 0,
});

const StyledTable = styled(Table)({
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
});

const StyledTableHead = styled(TableHead)({
    backgroundColor: "#252525",
    "& .MuiTableCell-root": {
        borderBottom: "none",
    },
});

const StyledTableCellHeader = styled(TableCell)({
    border: "1px dotted #333",
    color: "#98FF98",

    letterSpacing: "2px",
    textAlign: "center",
    padding: "16px",
});

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    backgroundColor: "#202020",
    height: "100%",
    transition: "background-color 0.3s ease",
    "&:hover": {
        color: "#222",
        backgroundColor: "#1a1a1a",
    },
    display: 'table-row',
    overflow: 'hidden',

    "& .MuiTableCell-root": {
        borderBottom: 'none',
        padding: '16px',
        display: 'table-cell',
    },
    '& .MuiTableCell-root:last-child': {
        borderBottom: 'none',
    },
}));

const StyledTableCell = styled(TableCell)({
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    border: "1px dotted #333",
    color: "#CCC",
    "&:hover": {
        color: "#98FF98",
    },
});

const DownloadLink = styled(Link)({
    width: "100%",
    height: "100%",
    color: "#98FF98",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",

    letterSpacing: "0.25px",
    textDecoration: "none",
    "&:hover": {
        color: "#222",
    }
});


const MediaTable = ({ mediaData }) => {
    const sortedMediaData = mediaData ? [...mediaData].sort(
        (a, b) => new Date(b.created) - new Date(a.created)
    ) : [];
    const isMobile = useMediaQuery("(max-width: 800px)");
    const isMobileSm = useMediaQuery("(max-width: 440px)");
    const isMobileXs = useMediaQuery("(max-width: 375px)");

    return (
        <Paper
            elevation={0}
            sx={{
                backgroundColor: "transparent",
                borderRadius: "8px",
            }}
        >
            <StyledTableContainer>
                <StyledTable sx={{ p: 2 }}>
                    <StyledTableHead>
                        <TableRow>
                            <StyledTableCellHeader sx={{
                                fontSize: isMobileXs ? "14px" : isMobileSm ? "16px" : isMobile ? "18px" : "22px",
                            }}>Video</StyledTableCellHeader >
                            <StyledTableCellHeader sx={{
                                fontSize: isMobileXs ? "14px" : isMobileSm ? "16px" : isMobile ? "18px" : "22px",
                            }}>File</StyledTableCellHeader>
                        </TableRow>
                    </StyledTableHead>
                    <TableBody>
                        {sortedMediaData.map((item, index) => (
                            <StyledTableRow key={index}>
                                <>
                                    <StyledTableCell><Link href={item.downloadUrl || "#"}
                                        target="_blank"
                                        rel="noopener noreferrer" sx={{
                                            textDecoration: "none", color: "#DDD",
                                            "&:hover": {
                                                color: "#98FF98",
                                            },
                                        }}><Typography variant="h5" component="span" sx={{

                                            letterSpacing: isMobileSm ? "0px" : isMobile ? "0.25px" : "2px", fontSize: isMobileSm ? "16px" : isMobile ? "18px" : '24px'
                                        }}>{item.title}</Typography></Link></StyledTableCell>
                                    <StyledTableCell>
                                        <Box sx={{
                                            mx: "auto", maxWidth: "250px", height: isMobile ? "35px" : "45px", borderRadius: "8px", color: "#98FF98", backgroundColor: "#303030",
                                            "&:hover": {
                                                color: "#222",
                                                backgroundColor: "#98FF98",
                                            },
                                        }}><Typography variant="h5" component="span" sx={{
                                            width: "100%", height: isMobile ? "35px" : "45px", fontSize: isMobileSm ? "16px" : isMobile ? "18px" : '22px',
                                            "&:hover": {
                                                color: "#222",
                                            }
                                        }}>
                                                <DownloadLink
                                                    href={item.downloadUrl || "#"}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <GetAppIcon fontSize={isMobile ? "medium" : "large"} />
                                                    {isMobileXs ? "" : "Download"}
                                                </DownloadLink></Typography>
                                        </Box>
                                    </StyledTableCell>
                                </>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </StyledTableContainer>
        </Paper >
    );
};

export default MediaTable;
